var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthergoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9943 53.2812H63.0261C61.8875 53.2812 60.965 54.2041 60.965 55.3423V63.6799C60.965 62.5418 60.0422 61.6189 58.904 61.6189H51.9354C50.7968 61.6189 49.8743 62.5413 49.8743 63.6799V69.1768C49.8743 68.0386 48.9514 67.1157 47.8133 67.1157H40.8446C39.706 67.1157 38.7836 68.0386 38.7836 69.1768V74.2939C38.7836 73.1557 37.8607 72.2328 36.7221 72.2328H29.7539C28.6158 72.2328 27.6929 73.1552 27.6929 74.2939V78.2065H72.0558V55.3423C72.0558 54.2041 71.1329 53.2812 69.9943 53.2812Z",
    fill: "#A7C7D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9758 54.1516C63.4946 54.1516 63.105 53.762 63.105 53.2812V21.6507C63.105 21.1699 63.4946 20.7803 63.9758 20.7803C64.4566 20.7803 64.8462 21.1699 64.8462 21.6507V53.2812C64.8462 53.762 64.4562 54.1516 63.9758 54.1516Z",
    fill: "#838EAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7836 78.2061H27.6929V74.2935C27.6929 73.1553 28.6158 72.2324 29.7539 72.2324H36.7225C37.8607 72.2324 38.7836 73.1549 38.7836 74.2935V78.2061Z",
    fill: "#E4E6EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 78H39V69.0442C39 67.9153 39.9153 67 41.0442 67H47.9558C49.0847 67 50 67.9153 50 69.0442V78Z",
    fill: "#C8CCD8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78H50V63.988C50 62.8902 50.9149 62 52.0442 62H58.9558C60.0847 62 61 62.8898 61 63.988V78Z",
    fill: "#838EAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72 78H61V55.0672C61 53.9257 61.9149 53 63.0442 53H69.9554C71.0847 53 72 53.9257 72 55.0672V78Z",
    fill: "#4C5A81"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1309 79H24.8691C24.389 79 24 78.5524 24 78C24 77.4476 24.389 77 24.8691 77H75.1309C75.611 77 76 77.4476 76 78C76 78.5524 75.611 79 75.1309 79Z",
    fill: "#394461"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64 30H74.6417C74.9714 30 75.1254 29.5708 74.878 29.342L72.1137 26.7822C71.9517 26.6327 71.9517 26.3677 72.1137 26.2178L74.878 23.6585C75.1254 23.4292 74.9714 23 74.6417 23H64V30Z",
    fill: "#AF8EFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8442 33L53.052 39.5313C51.9999 40.1142 51.7122 41.1384 51.345 42.4577L49 50.9152L52.0971 52L54.7468 48.5133L56.9772 41.6367L62.9116 37.9597C64.5699 36.9324 65.3585 34.908 64.8442 33Z",
    fill: "#C8CCD8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8442 33L63.4836 33.7573C63.2544 34.9571 62.547 36.0408 61.4771 36.7069L56.0697 40.0732C55.7294 40.2848 55.4738 40.6144 55.3484 41.0017L54.5763 43.3936C53.7738 45.8794 51.9509 47.8819 49.5864 48.8748L49 51L54.7468 48.5871L56.9772 41.678L62.9116 37.9832C64.5699 36.951 65.3585 34.917 64.8442 33Z",
    fill: "#838EAE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.686 49L58.0458 53.1666C58.6028 53.9402 59.0872 54.484 58.9867 55.3351L58.2009 62H56.1504L55.6144 56.2704C55.5818 55.9235 55.3727 55.623 55.0678 55.4851L49 51.4451L54.686 49Z",
    fill: "#445174"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.331 51.3698L48.0043 57.4924C47.9829 58.0002 48.0527 58.3434 47.8578 58.7212L44 67H46.1687L51.9692 59.1408C52.3083 58.7382 52.3477 58.1915 52.462 57.6884L54 49L48.331 51.3698Z",
    fill: "#4C5A81"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6864 34.8354L55.776 36.4404C56.2879 37.1945 55.8927 38.1195 54.8928 38.5058L54.0509 38.831C53.051 39.2173 51.8256 38.919 51.3136 38.1646L50.224 36.5596C49.7121 35.8051 50.1073 34.8805 51.1072 34.4942L51.9491 34.169C52.9485 33.7827 54.1739 34.081 54.6864 34.8354Z",
    fill: "#E4E6EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthergoal);
export default __webpack_public_path__ + "static/media/othergoal.db470a18db06b24d0d16dab3a6e5cc8c.svg";
export { ForwardRef as ReactComponent };